module.exports = __webpack_public_path__ + "static/img/99371acec430fc7d721a9e96c140b013.fec8f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/99371acec430fc7d721a9e96c140b013.png
// module id = bN7O
// module chunks = 1